import { createContext, useContext } from 'react';

import type { EduzzThemeMode } from '@eduzz/shared';

export type ThemeContextValue = {
  theme: EduzzThemeMode;
  setTheme(mode: EduzzThemeMode): void;
  toggle(): void;
};

export const ThemeContext = createContext<ThemeContextValue>({
  theme: 'light',
  setTheme: () => null,
  toggle: () => null
});

export function useTheme() {
  return useContext(ThemeContext);
}
